(() => {
  if (window.PlanetaHeaderAccountPopover) {
    window.PlanetaHeaderAccountPopover(document);
    return;
  }

  const selector = '.header__buttons > shopify-account';
  const desktop = matchMedia('(min-width: 751px)');
  const page = document.documentElement;
  let active = null;
  let frame = 0;

  function release() {
    active?.removeAttribute('data-header-account-open');
    active?.removeAttribute('data-header-account-closing');
    active = null;
    page.classList.remove('header-account-open');
    observer?.disconnect();
    modalObserver.disconnect();
    cancelAnimationFrame(frame);
    frame = 0;
  }
  // Keep the scroll-container fix through Shopify's native closing animation.
  const modalObserver = new MutationObserver(() => {
    if (page.style.overflow !== 'hidden') release();
  });

  function position(account) {
    if (!account?.isConnected) return;
    if (!desktop.matches) {
      account.style.removeProperty('--shopify-account-dialog-position-top');
      account.style.removeProperty('--header-account-right');
      account.style.removeProperty('--header-account-max-height');
      return;
    }
    const header = account.closest('header.header');
    if (!header) return;
    const rect = header.getBoundingClientRect();
    // The native modal reserves a scrollbar gutter that clientWidth can include.
    const width = document.documentElement.getBoundingClientRect().width;
    const height = window.innerHeight;
    const top = Math.max(12, Math.min(rect.bottom + 10, height - 120));
    account.style.setProperty('--shopify-account-dialog-position-top', `${Math.round(top)}px`);
    account.style.setProperty('--header-account-right', `${Math.max(12, Math.round(width - rect.right))}px`);
    account.style.setProperty('--header-account-max-height', `${Math.max(96, Math.floor(height - top - 12))}px`);
  }

  function schedule() {
    if (!active || frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      position(active);
    });
  }
  const observer = window.ResizeObserver ? new ResizeObserver(schedule) : null;

  function init(root) {
    root.querySelectorAll(selector).forEach(position);
  }
  // Shopify's open/close events do not bubble. Capture preserves its native interaction.
  document.addEventListener('open', event => {
    if (!event.target.matches?.(selector)) return;
    if (active && active !== event.target) release();
    active = event.target;
    active.removeAttribute('data-header-account-closing');
    active.setAttribute('data-header-account-open', '');
    page.classList.add('header-account-open');
    modalObserver.observe(page, { attributes: true, attributeFilter: ['style'] });
    position(active);
    observer?.disconnect();
    const header = active.closest('header.header');
    if (header) observer?.observe(header);
  }, true);
  document.addEventListener('close', event => {
    if (event.target !== active) return;
    active.removeAttribute('data-header-account-open');
    active.setAttribute('data-header-account-closing', '');
    if (page.style.overflow !== 'hidden') release();
  }, true);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { capture: true, passive: true });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (!active || !event.target.contains(active)) return;
    active.close?.();
    release();
  });
  window.PlanetaHeaderAccountPopover = init;
  init(document);
})();
